import {default as cx} from "classnames"
import {Skeleton} from "primereact/skeleton"

export const getCellCustom = (col, row, editAction, deleteAction, showDelete = false) => {
    if (!row) return ""
    if (row.loading) {
        return <Skeleton className="w-100 h-40px" />
    }

    const {_, field} = col
    if (field === "active") {
        return (
            <div
                className={cx(
                    "badge badge-lg fw-bold py-2 px-4",
                    row.active ? "badge-light-success" : "badge-light-danger",
                )}
            >
                {row.active ? "Active" : "Inactive"}
            </div>
        )
    } else if (field === "actions") {
        return (
            <div>
                <button
                    className="btn btn-icon btn-light btn-active-light-primary w-30px h-30px w-md-40px h-md-40px hover-elevate-down position-relative"
                    onClick={() => editAction(row)}
                >
                    <i className="fas fa-edit text-primary fs-3"></i>
                </button>
                {showDelete && row.active && (
                    <button
                        className="btn btn-icon btn-light btn-active-light-danger w-30px h-30px w-md-40px h-md-40px hover-elevate-down position-relative"
                        onClick={() => deleteAction(row)}
                    >
                        <i className="fas fa-trash fs-3 text-danger"></i>
                    </button>
                )}
            </div>
        )
    } else {
        return row[field]
    }
}

export const getExportableField = (col, row) => {
    if (!row) return ""
    const {_, field} = col
    if (field === "account") {
        let user_name =
            row.first_name !== "" && row.last_name !== "" ? `${row.first_name} ${row.last_name}` : row.account
        return user_name
    } else if (field === "enabled") {
        return row.enabled ? "Active" : "Inactive"
    } else {
        return row[field]
    }
}